import type { AmnesspecifikInstans } from '../types'
import ElevmaterialVy from './ElevmaterialVy'
import { LararFigurer } from './Figurer'

/** Blockets ämnesspecifika instans: syftet på en rad, genomförandet som en
 *  tidslinje, elevmaterialet för sig och lärarnoteringarna sist. Uppdelningen
 *  kommer från datat (schemats amnesspecifik_instans) — den ska inte skrivas
 *  ihop till en prosaklump igen, vilket var precis vad den gamla textsträngen
 *  blev när radbrytningarna kollapsade i HTML. */
/** Övergångsstöd: en incheckad ögonblicksbild av src/content/ som synkats före
 *  2026-07-25 har instansen kvar som textsträng. Bygget i CI synkar om från
 *  källan och får objektformen, men dev-servern kan möta den gamla — då visas
 *  texten som syfte i stället för att vyn kraschar. Kan tas bort när src/content/
 *  regenererats och inga strängar återstår (synken varnar för dem). */
const normalisera = (instans: AmnesspecifikInstans | string): AmnesspecifikInstans =>
  typeof instans === 'string'
    ? { syfte: instans, forberedelser: [], steg: [], elevmaterial: [], lararnoteringar: [] }
    : instans

export default function InstansVy({ instans }: { instans: AmnesspecifikInstans | string }) {
  const { syfte, forberedelser, steg, elevmaterial, lararnoteringar } = normalisera(instans)

  return (
    <div className="instans">
      {syfte && <p className="instans-syfte">{syfte}</p>}

      {forberedelser.length > 0 && (
        <section className="instans-forberedelser">
          <h5>Förbered innan</h5>
          <ul>
            {forberedelser.map((punkt, i) => (
              <li key={i}>{punkt}</li>
            ))}
          </ul>
        </section>
      )}

      {steg.length > 0 && (
        <ol className="instans-steg">
          {steg.map((s, i) => (
            <li key={i} className="instans-steg-post">
              <p className="instans-steg-rubrik">
                <span className="instans-steg-namn">{s.rubrik}</span>
                {s.minuter !== null && <span className="instans-steg-tid">{s.minuter} min</span>}
              </p>
              {s.larartext && <p className="instans-steg-text">{s.larartext}</p>}
              {s.fragor.length > 0 && (
                <ul className="instans-fragor">
                  {s.fragor.map((fraga, j) => (
                    <li key={j}>{fraga}</li>
                  ))}
                </ul>
              )}
              <LararFigurer illustrationer={s.illustrationer} />
            </li>
          ))}
        </ol>
      )}

      {elevmaterial.length > 0 && (
        <section className="instans-elevmaterial">
          <h5>
            Elevmaterial <span className="instans-antal">{elevmaterial.length}</span>
          </h5>
          {elevmaterial.map((material, i) => (
            <ElevmaterialVy key={i} material={material} />
          ))}
        </section>
      )}

      {lararnoteringar.length > 0 && (
        <section className="instans-lararnoteringar">
          <h5>Bara för dig</h5>
          <ul>
            {lararnoteringar.map((notering, i) => (
              <li key={i}>{notering}</li>
            ))}
          </ul>
        </section>
      )}
    </div>
  )
}
